import {
  AuditActionEnum,
  IPostAuditAction,
  IPostAuditSuccessAction,
  IPostAuditFailedAction
} from '.';

import {
  IAuditLog,
} from '../../services';


export const PostAuditAction = (auditLog: IAuditLog) => {
  return {
    type: AuditActionEnum.PostAudit,
    state: { loading: true, auditLog: auditLog },   
  } as IPostAuditAction;
};

export const PostAuditSuccessAction = () => {
  return {
    type: AuditActionEnum.PostAuditSuccess,
    state: { loading: false, isPosAuditSuccess: true},
  } as IPostAuditSuccessAction;
};

export const PostAuditFailedAction = (message: string) => {
  return {
    type: AuditActionEnum.PostAuditFailed,
    state: { loading: false, exceptionMessage: message },
  } as IPostAuditFailedAction;
};
